import type { FetchOptions } from 'ofetch'

import useApiClient from './api-client'
import type {
  FmemberReqSMSRequest,
  FmemberReqSMSVerify,
  MemberReqSMSRes,
  FmemberGetDeletionData,
  EatigoMemberInfoData,
  MemberSuspendedRes,
} from '@/types/api'

export async function getMember() {
  const api = useApiClient<EatigoMemberInfoData>()
  const result = await api('/member')
  return result
}

export const postMember = async (payload: Partial<Record<keyof EatigoMemberInfoData, any>>) => {
  const api = useApiClient<FmemberReqSMSRequest>()
  const result = await api('/member', {
    method: 'POST',
    body: payload,
  })
  return result
}

export const getSmsRequest = async (payload: Omit<FmemberReqSMSRequest, 'verification_token'>) => {
  const api = useApiClient<MemberReqSMSRes>()
  const result = await api('/member/sms-expired', { query: payload })
  return result
}

export const postSmsRequest = async (payload: FmemberReqSMSRequest) => {
  const api = useApiClient<MemberReqSMSRes>()
  const result = await api('/member/sms-request', {
    method: 'POST',
    body: payload,
  })
  return result
}

export const postSmsVerify = async (payload: FmemberReqSMSVerify) => {
  const api = useApiClient()
  const result = await api('/member/sms-verify', {
    method: 'POST',
    body: payload,
  })
  return result
}

export const putFavoriteById = async (id: number, args: FetchOptions = {}) => {
  const api = useApiClient()
  const result = await api(`/member/favorite/${id}`, {
    ...args,
    method: 'PUT',
  })
  return result
}

export const deleteFavoriteById = async (id: number, args: FetchOptions = {}) => {
  const api = useApiClient()
  const result = await api(`/member/favorite/${id}`, {
    ...args,
    method: 'DELETE',
  })
  return result
}

export const getMemberDeletion = async (token: string) => {
  const api = useApiClient<FmemberGetDeletionData>()
  const result = await api(`/member/deletion/${token}`)
  return result
}

export const postMemberDeletion = async (token: string) => {
  const api = useApiClient()
  const result = await api(`/member/deletion/${token}`, {
    method: 'POST',
  })
  return result
}

export const getMemberSuspended = async () => {
  const api = useApiClient<MemberSuspendedRes>()
  const result = await api(`/member/suspended`)
  return result
}

export const postMemberRegionChange = async (regionId: number) => {
  const api = useApiClient()
  const result = await api(`/member/region/${regionId}`, {
    method: 'POST',
  })
  return result
}
